import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Outlet } from "react-router-dom";
import { USER_LOGGED_IN } from "../../Reducer/authSlice";
import Login from "../../Auth/Login";
import TeacherInfo from "./TeacherInfo";
import WaitingApproval from "./WaitingApproval";
import TutorNav from "./TutorNav";
import DashMobileNav from "../../components/DashMobileNav";

const TUTOR_NAV_ITEMS = [
    { to: '/dashboard/tutor', icon: 'fa-light fa-grid-2', label: 'Dashboard', end: true },
    { to: '/dashboard/chat', icon: 'fa-light fa-message-lines', label: 'Messages', badge: 'unread' },
    { to: '/dashboard/my-courses', icon: 'fa-light fa-chalkboard-user', label: 'Courses' },
    { to: '/dashboard/all-enrollment-courses', icon: 'fa-light fa-list', label: 'Classes' },
    { to: '/dashboard/earnings', icon: 'fa-light fa-wallet', label: 'Earnings' },
    { to: '/dashboard/transactions', icon: 'fa-light fa-chart-bar', label: 'Transactions' },
    { to: '/dashboard/withdraw', icon: 'fa-light fa-money-bill-transfer', label: 'Withdraw' },
    { to: '/dashboard/settings', icon: 'fa-light fa-user-gear', label: 'Settings' },
    { to: '/dashboard/subscription', icon: 'fa-light fa-crown', label: 'Subscription' },
    { to: '/dashboard/help', icon: 'fa-light fa-circle-info', label: 'Help' },
];

export default function TutorDashboard(){
    const { user, accessToken } = useSelector((state) => state.authReducer);
 
     // !user ||
  if (!accessToken) {
    return (
      <>
        <Login />
      </>
    );
  }

  if(user.approved==0 && user.teacher_info==''){
    return (
      <>
        <TeacherInfo />
      </>
    );
  }

  if(user.approved==0 && user.teacher_info!=''){
    return (
      <>
        <WaitingApproval />
      </>
    );
  }

    return (
        <div className="dash-shell">
        <div className="breadcrumb-bar breadcrumb-bar-info">
          <div className="container">
            <div className="row">
              <div className="col-md-12 col-12">
                <div className="breadcrumb-list">
                  <h2 className="breadcrumb-title">Tutor Dashboard</h2>
                  <nav aria-label="breadcrumb" className="page-breadcrumb">
                    <ol className="breadcrumb">
                      <li className="breadcrumb-item"><a href="#">Home</a></li>
                      <li className="breadcrumb-item active" aria-current="page">Dashboard</li>
                    </ol>
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="page-content student-panel">
          <div className="container">
            <DashMobileNav items={TUTOR_NAV_ITEMS} />
            <div className="row">
              <div className="col-xl-3 col-lg-3 panelSidebar">
              <TutorNav/>
              </div>
              <div className="col-lg-9 col-xl-9 col-12">
              <Outlet/>
              </div>
            </div>
          </div>
        </div>
        </div>
    )
}